'use client';

import * as Sentry from '@sentry/nextjs';
import {useEffect} from 'react';

// global-error replaces the root layout, so it must render its own <html>/<body>
// and cannot rely on the app's fonts, providers or Tailwind globals. Inline styles
// mirror frontend/src/components/system/error_page.tsx.
export default function GlobalError({
  error,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang='en'>
      <head>
        {/* Overpass = the app's global font; layout is bypassed here, so load it directly. */}
        {/* eslint-disable-next-line @next/next/no-page-custom-font -- global-error replaces the root layout */}
        <link
          href='https://fonts.googleapis.com/css2?family=Overpass:wght@400;500;600;700&display=swap'
          rel='stylesheet'
        />
      </head>
      <body
        style={{
          fontFamily: 'Overpass, sans-serif',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: '100vh',
          margin: 0,
        }}>
        <main style={{textAlign: 'center', padding: '4rem 1rem'}}>
          {/* eslint-disable-next-line @next/next/no-img-element -- error page, LCP optimization irrelevant */}
          <img
            src='/img/robot.svg'
            alt='Error'
            style={{width: '600px', maxWidth: '100%', margin: 'auto'}}
            loading='lazy'
          />
          <br />
          <h2>Something went wrong</h2>
          <p>Please try again, or refresh the page if the problem persists.</p>
        </main>
      </body>
    </html>
  );
}
